import { Typography } from '@mui/material';

const Footer = () => (
    <Typography variant='caption' className='text-gray px-25 py-20 text-center'>
      @ {new Date().getFullYear()} TOTO IS. All Rights Reserved. v1.0.1
    </Typography>
);

export default Footer
